import { AllocationCards as CXAllocationCards } from '@sanlamcx/react-ui-next-allocation-cards';

export const AllocationCard = CXAllocationCards;
